import {Component} from '@angular/core';
import {SelectSnapshot} from '@ngxs-labs/select-snapshot';
import {SalesCpiAsideState} from '../../../../../../state/sales-cpi/sales-cpi-aside.state';

@Component({
    selector: 'app-cpi-cancellation-aside',
    templateUrl: './cpi-cancellation-aside.component.html',
})
export class CpiCancellationAsideComponent {

    @SelectSnapshot(SalesCpiAsideState.step) step: number;

}
